import React, { useState } from "react";
import { Box, Typography, IconButton, useTheme, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BlockIcon from "@mui/icons-material/Block";

const ChatHeader = ({ user, onClose, isOnline, onBlock }) => {
  const theme = useTheme();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleBlockClick = () => {
    setConfirmOpen(true);
  };

  const handleConfirmBlock = () => {
    setConfirmOpen(false);
    onBlock();
  };

  return (
    <>
      <Box sx={{
        p: 2,
        bgcolor: theme.palette.primary.main,
        color: "#fff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
          {/* Enhanced 13px Online Status */}
          <Box
            sx={{
              position: 'relative',
              width: 13,
              height: 13,
              borderRadius: '50%',
              bgcolor: isOnline ? '#44b700' : '#666',
              boxShadow: isOnline 
                ? '0 0 6px rgba(68, 183, 0, 0.8), inset 0 1px 2px rgba(255,255,255,0.4)' 
                : '0 1px 3px rgba(0,0,0,0.3)',
              border: isOnline ? '1px solid rgba(255,255,255,0.4)' : 'none',
              transition: 'all 0.25s ease',
              
              // Pulsing ring effect
              '&::before': {
                content: '""',
                position: 'absolute',
                top: '-2px',
                left: '-2px',
                right: '-2px',
                bottom: '-2px',
                borderRadius: '50%',
                bgcolor: 'rgba(68, 183, 0, 0.4)',
                opacity: isOnline ? 1 : 0,
                animation: isOnline ? 'pulse-ring 1.8s infinite' : 'none',
                zIndex: -1
              }
            }}
          />
          
          <Typography 
            variant="subtitle1" 
            sx={{ 
              fontWeight: 600,
              fontSize: '0.95rem'
            }}
          >
            {user.firstName || user.name}
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <IconButton 
            onClick={handleBlockClick}
            sx={{ 
              color: '#fff',
              p: 0.5,
              '&:hover': {
                bgcolor: 'rgba(255,255,255,0.15)'
              }
            }}
            title="Block User"
          >
            <BlockIcon sx={{ fontSize: 20 }} />
          </IconButton>
          
          <IconButton 
            onClick={onClose} 
            sx={{ 
              color: '#fff',
              p: 0.5,
              '&:hover': {
                bgcolor: 'rgba(255,255,255,0.15)'
              }
            }}
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Box>
      </Box>

      {/* Confirmation Dialog */}
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Block User?</DialogTitle>
        <DialogContent>
          <Typography>
            Blocking this user will remove all favorations and prevent chat access. This action cannot be undone. Do you want to continue?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleConfirmBlock} color="error" variant="contained">
            Block User
          </Button>
        </DialogActions>
      </Dialog>
    </>
      
    //   <IconButton 
    //     onClick={onClose} 
    //     sx={{ 
    //       color: '#fff',
    //       p: 0.5,
    //       '&:hover': {
    //         bgcolor: 'rgba(255,255,255,0.15)'
    //       }
    //     }}
    //   >
    //     <CloseIcon sx={{ fontSize: 20 }} />
    //   </IconButton>
    // </Box >
    
  );
};

export default ChatHeader;
